import React, { useEffect } from "react";
import { Footer } from "./footer";
import { Header } from "./header";
import IntroVideo from "./introVideo";
import Menu from "./menu/Menu.component";

import { Phone } from "./phone/Phone.component";
import { SynopsisObject } from "./menu/menuContent/data.types";
import Homepage from "./homepage";

import { PhoneSlide } from "../contexts/phone/Phone.types";
import { usePhone } from "../contexts/phone/phone.hook";
import { useMenu } from "../contexts/menu/menu.hook";
import { useVideoSettings } from "../contexts/videoSettings/videoSettings.hook";
import useResponsive from "../hooks/useResponsive";

interface SkillhouseWrapperProps {
  phoneSlides: Array<PhoneSlide>;
  synopsis: SynopsisObject;
  buyTicketsLink: string;
  trailerLink: string;
}

export const SkillhouseWrapper = ({
  phoneSlides,
  synopsis,
  buyTicketsLink,
  trailerLink,
}: SkillhouseWrapperProps) => {
  const { isPhoneOpen, setIsPhoneOpen } = usePhone();
  const { isMenuOpen } = useMenu();
  const { isPlayingIntroVideo } = useVideoSettings();
  const { isMobile } = useResponsive();

  useEffect(() => {
    if (isPhoneOpen || isMenuOpen || isPlayingIntroVideo) return;

    let startY = null;

    const handleWheel = (e) => {
      if (e.deltaY > 50) {
        setIsPhoneOpen(true);
      }
    };

    const handleTouchStart = (e) => {
      if (isMobile) {
        if (e.touches.length === 1) {
          startY = e.touches[0].clientY;
        }
      }
    };

    const handleTouchMove = (e) => {
      if (isMobile) {
        if (startY !== null) {
          const deltaY = e.touches[0].clientY - startY;
          if (deltaY < -50) {
            setIsPhoneOpen(true);
          }
        }
      }
    };

    window.addEventListener("wheel", handleWheel, { passive: true });
    window.addEventListener("touchstart", handleTouchStart, { passive: true });
    window.addEventListener("touchmove", handleTouchMove, { passive: true });

    return () => {
      window.removeEventListener("wheel", handleWheel);
      window.removeEventListener("touchstart", handleTouchStart);
      window.removeEventListener("touchmove", handleTouchMove);
    };
  }, [isPhoneOpen, isMenuOpen, isPlayingIntroVideo, setIsPhoneOpen, isMobile]);

  return (
    <>
      <Header buyTicketsLink={buyTicketsLink} />
      <main>
        <Menu
          synopsisData={synopsis}
          buyTicketsLink={buyTicketsLink}
          trailerLink={trailerLink}
        />
        <IntroVideo>
          <Homepage>
            <Phone phoneSlides={phoneSlides} />
          </Homepage>
        </IntroVideo>
      </main>
      <Footer />
    </>
  );
};
